export default "__VITE_ASSET__DoIC7Fg$__"